import Spinners from "components/Shared/Spinners"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { Container, Row } from "reactstrap"
import { getPrivacyPolicy } from "store/actions/globalSettingAction"
import { isArabicPublicLang } from "utils/pageContentUtils"
import { sanitizeLegalHtml } from "utils/sanitizeHtml"

const AppPrivacyPolicy = ({ langOverride }) => {
  const dispatch = useDispatch()
  const { i18n } = useTranslation()
  const { lang, identifier } = useParams()
  const resolvedLang =
    langOverride || lang || i18n.language || identifier || "en"
  const isArabic = isArabicPublicLang(resolvedLang)

  const { loading, privacyPolicy } = useSelector(state => state.GlobalSettings)

  useEffect(() => {
    dispatch(getPrivacyPolicy())
  }, [resolvedLang, dispatch])

  const content = isArabic
    ? privacyPolicy?.descriptionAr
    : privacyPolicy?.description

  if (loading) return <Spinners />

  return (
    <React.Fragment>
      <div className="frutiger_font app_content">
        <Container>
          <Row className="my-3" dir={isArabic ? "rtl" : "ltr"}>
            <div
              className="app_content"
              dir={isArabic ? "rtl" : "ltr"}
              dangerouslySetInnerHTML={{ __html: sanitizeLegalHtml(content) }}
            />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AppPrivacyPolicy
